import React from 'react';
import Alert from 'src/shared/components/ui/alert';
import { PortfolioSpeciesSourceProvider } from 'src/app/portfolio/state/portfolioSpeciesSource';
import PortfolioSummary from '../portfolio-summary/PortfolioSummary';

/**
 * The portfolio summary with its species cards read from the prediction grid.
 *
 * The same components as the live page, mounted inside a provider that changes where
 * the species cards' query points — see portfolioSpeciesSource. The habitat and
 * overview halves are unaffected; the grid holds neither.
 *
 * Internal only, enforced by route availability rather than here: the banner below
 * says the page is not shown to customers, and a reachable URL would make that untrue.
 */
const NextPortfolioSummary = () => (
    <PortfolioSpeciesSourceProvider source='grid'>
        <div className='flex flex-col gap-3' data-testid='next-portfolio-summary'>
            <Alert severity='warning' data-testid='next-portfolio-summary-internal-only'>
                Internal only — not shown to customers. The species cards come from the global prediction grid, not the portfolio pipeline
                behind the current summary, so their figures will differ.
            </Alert>
            <PortfolioSummary />
        </div>
    </PortfolioSpeciesSourceProvider>
);

export default NextPortfolioSummary;
